// extracted by mini-css-extract-plugin
export default {"regularLabelTitle":"InputLabel_regularLabelTitle__7eauG"};